"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServGoogBase = void 0;
const base_1 = require("./base");
/**
 * Google Base
 *
 * See: https://developers.google.com/gtagjs/reference/api
 */
class AnServGoogBase extends base_1.AnServBase {
    static isLoaded() {
        return (window.gtag !== undefined);
    }
    static sendInit(pixelId, userId, email, coupon) {
        gtag("js", new Date());
        gtag("config", pixelId, { send_page_view: false });
        this.logEvent({
            cmd: "config",
            pixelId: pixelId
        });
        return true;
    }
    static sendIdentify(pixelId, userId, email) {
        const configProps = {
            user_id: userId.toString()
        };
        gtag("config", pixelId, configProps);
        this.logEvent({
            cmd: "config",
            pixelId: pixelId,
            configProps: configProps
        });
        return true;
    }
    /**
     * See:
     * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_purchases
     *
     */
    static sendStdEventSubscriptionPurchase(category, label, userId, price, itemName, coupon) {
        const props = {
            event_category: category,
            event_label: label,
            transaction_id: userId,
            value: price,
            currency: "USD",
            coupon: coupon,
            items: [
                {
                    "id": userId,
                    "name": itemName,
                    "price": price
                }
            ]
        };
        gtag("event", "purchase", props);
        this.logEvent({
            cmd: "event",
            eventAction: "purchase",
            eventProps: props
        });
        return true;
    }
    static sendStdEventEcommPurchase(category, label, orderId, price, coupon) {
        const props = {
            event_category: category,
            event_label: label,
            transaction_id: orderId,
            value: price,
            currency: "USD",
            coupon: coupon,
        };
        gtag("event", "purchase", props);
        this.logEvent({
            cmd: "event",
            eventAction: "purchase",
            eventProps: props
        });
        return true;
    }
    static sendStdEventEcommAddToCart(productId) {
        const props = {
            "items": [
                {
                    "id": productId,
                }
            ]
        };
        gtag("event", "add_to_cart", props);
        this.logEvent({
            cmd: "event",
            eventAction: "purchase",
            eventProps: props,
        });
        return true;
    }
    /**
     * See:
     * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_purchases
     *
     */
    static sendStdEventBeginCheckout(category, label, item) {
        const props = {
            event_category: category,
            event_label: label,
            items: [
                {
                    "name": item
                }
            ]
        };
        gtag("event", "begin_checkout", props);
        this.logEvent({
            cmd: "event",
            eventAction: "begin_checkout",
            eventProps: props
        });
        return true;
    }
    static sendStdEventSignUp(category, label) {
        const props = {
            event_category: category,
            event_label: label
        };
        gtag("event", "sign_up", props);
        this.logEvent({
            cmd: "event",
            eventAction: "sign_up",
            eventProps: props
        });
        return true;
    }
    static sendCustEventAddPaymentInfo(category, label) {
        const props = {
            event_category: category,
            event_label: label
        };
        gtag("event", "add_payment_info_cust", props);
        this.logEvent({
            cmd: "event",
            eventAction: "add_payment_info_cust",
            eventProps: props
        });
        return true;
    }
    static sendCustEventReviewPaymentInfo(category, label) {
        const props = {
            event_category: category,
            event_label: label
        };
        gtag("event", "review_payment_info_cust", props);
        this.logEvent({
            cmd: "event",
            eventAction: "review_payment_info_cust",
            eventProps: props
        });
        return true;
    }
    static sendCustEventBeginSignup(category, label) {
        const props = {
            event_category: category,
            event_label: label
        };
        gtag("event", "begin_signup_cust", props);
        this.logEvent({
            cmd: "event",
            eventAction: "begin_signup_cust",
            eventProps: props
        });
        return true;
    }
    static sendCustEventNested(pixelId, eventName, eventProps) {
        const eventPropsNew = Object.assign({}, eventProps);
        if (eventPropsNew.send_to === undefined || eventPropsNew === null) {
            eventPropsNew.send_to = pixelId;
        }
        gtag("event", eventName, eventPropsNew);
        this.logEvent({
            cmd: "event",
            eventName: eventName,
            eventPropsNew: eventPropsNew
        });
        return true;
    }
    static sendPage(pixelId, tags = null) {
        const configProps = {
            page_title: document.title,
            page_location: location.href,
            page_path: location.pathname,
            page_referrer: document.referrer,
            referrer: document.referrer
        };
        gtag("config", pixelId, configProps);
        this.logEvent({
            cmd: "config",
            pixelId: pixelId,
            configProps: configProps
        });
        const pageViewProps = {
            send_to: pixelId
        };
        gtag("event", "page_view", pageViewProps);
        this.logEvent({
            cmd: "event",
            action: "page_view",
            pageViewProps: pageViewProps
        });
        return true;
    }
}
exports.AnServGoogBase = AnServGoogBase;
AnServGoogBase.serviceName = "GoogleBase";
